import React from 'react';
import { actions, elements, feedback } from '@ecosystem/newron-design-system';
import { Market } from '../types';

const { Button } = actions;
const { Icon } = elements;
const { Tooltip } = feedback;

type Props = {
  onApply: () => void;
  notPublishedMarkets?: Market[];
  notAvailableMarkets?: Market[];
  disabled?: boolean;
};

export function ApplyPeriodButton({
  onApply,
  notPublishedMarkets = [],
  notAvailableMarkets = [],
  disabled = false,
}: Props): React.JSX.Element {
  const showIncompleteTooltip = notPublishedMarkets.length > 0 || notAvailableMarkets.length > 0;

  return (
    <div className={'mx-3 self-end'}>
      <Tooltip placement="right">
        <div className="flex items-center gap-2">
          {showIncompleteTooltip && (
            <Icon color="lighter">
              <Icon.icons.Fractional />
            </Icon>
          )}
          <Button disabled={disabled} onClick={onApply}>
            Apply
          </Button>
        </div>

        {showIncompleteTooltip && (
          <Tooltip.Content>
            {notPublishedMarkets.length > 0 && (
              <>
                <p>Data is not available for:</p>
                <ul className="ml-5" style={{ listStyleType: 'disc' }}>
                  {notPublishedMarkets.slice(0, 4).map(({ label }, index) => (
                    <li key={`${index * 2}-${label}`}>{label}</li>
                  ))}
                  {notPublishedMarkets.slice(4).length > 0 && (
                    <span>{`and ${notPublishedMarkets.slice(4).length} more`}</span>
                  )}
                </ul>
              </>
            )}
            {notAvailableMarkets.length > 0 && (
              <>
                <p>Data is available for the below, but currently outside of your subscription:</p>
                <ul className="ml-5" style={{ listStyleType: 'disc' }}>
                  {notAvailableMarkets.slice(0, 4).map(({ label }, index) => (
                    <li key={`${index * 2}-${label}`}>{label}</li>
                  ))}
                  {notAvailableMarkets.slice(4).length > 0 && (
                    <span>{`and ${notPublishedMarkets.slice(4).length} more`}</span>
                  )}
                </ul>
              </>
            )}
          </Tooltip.Content>
        )}
      </Tooltip>
    </div>
  );
}
